import Model from 'src/app/common/model';
import UOMMasterModel from './uom.model';
import ItemTypesModel from './itemTypes.model';
import BusinessEntity from './businessEntity.model';
import BusinessItemsModel from './businessItems.model';
import UOMConversionModel from './uomConversion.model';
import CultureCategoryModel from './cultureCategory.model';

export default class ItemMasterModel extends Model {
  UOMMaster: UOMMasterModel;
  ReorderUOM: UOMMasterModel;
  ToUOM: UOMMasterModel;
  FromUOM: UOMMasterModel;
  ItemType: ItemTypesModel;
  BusinessEntityDetails: BusinessEntity;
  BusinessItem: Array<BusinessItemsModel>;
  UOMConversion: Array<UOMConversionModel>;
  conversion: UOMConversionModel;
  CultureCategory: CultureCategoryModel;
  feedTypes?: Array<IFeedTypes>;
  attachment: object;
  item_name?: string;
  feed_type_id?: number; //
  is_feed_type: boolean;
  description?: string;
  system: boolean;
  business_id: string;
  stockable: boolean;
  reorder_level_value?: number; //
  isInventory: boolean;
  uom_id: number;
  item_type_id: any;
  culture_category_id: number;
  reorder_uom_id?: number; //
  isBH: boolean;
  updated_date: string;
  updated_by: string;
  created_name: string;
  updated_name: string;
  created_by: string;
  created_date: string;
  farm_site_id?: string;
  stage?: string;
  transaction_date?: Date;
  pond_id?: number;
  sub_type: number;
  pellet_size: number;
  shape_id: number;
  packageType: number;
  species_type_id: number;
  usage: string;
  dosage: string;
  attachment_path: any;
  pond_culture_id: any;

  constructor() {
    super();
    this.UOMConversion = new Array();
    this.feedTypes = new Array();
    this.attachment = new Object();
  }
}

//////////////////////////////
//IFeedTypes
//////////////////////////////
export class IFeedTypes {
  pond_id?: number;
  feed_item_id?: number;
  mix_item_id?: number;
  feed_business_item_id?: number;
  feed_uom_id?: number;
  feed_qty_given?: number;
  mix_business_item_id?: number;
  mix_uom_id?: number;
  mix_qty_given?: number;

  constructor() {
  }
}

//////////////////////////////
//BrandingAttachments
//////////////////////////////
export class Attachments {
  file_path?: string;
  file_type: string;
  data: string;
  description: string;
  businessName?: string;
  isBH: number;

  constructor() {
  }
}
